

import React from 'react';
import MainLayout from '@/components/layouts/MainLayout';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const requestId = "PMT-" + Math.floor(10000 + Math.random() * 90000);

  return (
    <MainLayout allowedRoles={['author']}>
      <div className="max-w-md mx-auto mt-8">
        <Card>
          <CardHeader className="text-center pb-6">
            <div className="mx-auto bg-green-100 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
              <Check className="h-8 w-8 text-green-600" />
            </div>
            <CardTitle className="text-2xl">Payment Requested</CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <p className="mb-4">
              Your payment request has been successfully submitted. Our team will review your request and process it as soon as possible.
            </p>
            <div className="bg-gray-50 p-4 rounded-md mb-4">
              <p className="text-sm text-gray-500">Request ID</p>
              <p className="text-lg font-medium">{requestId}</p>
            </div>
            <p className="text-sm text-gray-500">
              You will receive email notifications when there are updates to your payment request.
            </p>
          </CardContent>
          <CardFooter className="flex justify-center gap-4">
            <Button 
              variant="outline" 
              onClick={() => navigate('/author/payments')}
            >
              View Payment History
            </Button>
            <Button 
              className="bg-royalty-600 hover:bg-royalty-700"
              onClick={() => navigate('/author/dashboard')}
            >
              Return to Dashboard
            </Button>
          </CardFooter>
        </Card>
      </div>
    </MainLayout>
  );
};

export default PaymentSuccess;

